<template>
  <body class="ui_index modal-open">
  <div class="overlay"> </div>
    <div class="modal_fixed">
      <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img src="/static/images/store/icon-close-back-popup.svg" class="btn_close" @click="goTOGetStarted">
        <p>
          {{ getTranslations.visitor_free_trial_modals_first }} <span>[ {{ freeTrialPoints[0] }} ]</span> {{ getTranslations.visitor_free_trial_modals_points }}<br>
          {{ getTranslations.visitor_free_trial_modals_points_count }}
        </p>
        <img src="/static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="goToRegistration">
          {{ getTranslations.visitor_free_trial_modals_claim_points }}
        </button>
      </div>
  </div>
  </body>

</template>

<script>
// achievements_modal_wheel_prize.html
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'freePlayPointsWon',
  computed: {
    ...mapState('common', [
      'freeTrialRedirectionUrl',
      'freeTrialPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapMutations('common', [
      'setFreeTrialUserPrice',
    ]),
    saveFreePoints() {
      this.setFreeTrialUserPrice(this.freeTrialPoints[0]);
      return this.freeTrialPoints[0];
    },
    goTOGetStarted() {
      this.$router.push('/');
    },
    goToRegistration() {
      if (this.getRefUrl === undefined && this.getClickId === undefined && this.publisherId === undefined && this.campaignId === undefined) this.$router.push(`${this.freeTrialRedirectionUrl}?totalPoints=${this.saveFreePoints()}`);
      else this.$router.push(`${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickId=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.campaignId || ''}&totalPoints=${this.saveFreePoints()}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/FreePlayPointsWon.vue